<template>
  <div class="dataset-invitation-confirm-dailog dialog col-block">
    <datasetCard
      :type="'community'"
      :dataset="dataset"
      :layoutType="'confirm'"
    ></datasetCard>
    <hr class="custom" :style="{ '--type': 'solid', '--color': '#DEDEDE', '--margin': '10px' }">
    <div class="information-container col-block">
      <div
        class="information"
        v-html="[
          $t('DIALOG.datasetInvitationConfirm.___info01', { user: [dataset.user.first_name, dataset.user.last_name].filter(x => x).join(' ') })
        ].join('<br>')"
      ></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" @click="e => $emit('changeModal', {}, true)">
        <span>{{ $t('COMMON.button.___accept') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import datasetCard from '../dataset/card.vue'

export default {
  components: {
    datasetCard
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // param
    dataset () {
      return this.param.dataset
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/datasetInvitationConfirm.vue